import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { WhatsAppMessage } from "../../aiConversations.types";
import {
  AiConversationSubRoute,
  ApiRoutesAiConversations,
} from "../../constants/enums";
import { SendMessageRequestBody } from "./sendMessage.types";

export const requestSendMessage = async ({
  conversationId,
  text,
  imageUrl,
  audioUrl,
}: SendMessageRequestBody): Promise<WhatsAppMessage> => {
  return await instance.post(
    buildUrl(
      ApiRoutesAiConversations.Conversations,
      conversationId,
      AiConversationSubRoute.Messages,
    ),
    { text, imageUrl, audioUrl },
  );
};
